import { AxiosError } from 'axios';

interface ApiErrorResponse {
    errorMessage?: string;
    errors?: string[];
    error?: string;
}

export function apiErrorHandler(err: unknown, defaultMessage = 'Erro inesperado'): never {
    if (err instanceof AxiosError) {
        const data = err.response?.data as ApiErrorResponse | undefined;

        if (data?.errors && data.errors.length > 0) {
            throw new Error(data.errors.join(', '));
        }
        if (data?.errorMessage) {
            throw new Error(data.errorMessage);
        }
        if (data?.error) {
            throw new Error(data?.error);
        }
    }

    if (err instanceof Error) {
        throw new Error(err.message || defaultMessage);
    }

    throw new Error(defaultMessage);
}

export default apiErrorHandler;